import { RemoteConstants } from "./RemoteConstants";

export function urlResource(path:string){
    if(!path) return "";
    if(path.startsWith("/")){
        path = path.substring(1);
    }
    path = path.replace("wsventa/", "");
    path = path.replace("resources/","");
    path = `resources/${path}`;
    return `${RemoteConstants.BASE_URL}${path}`;
}